import React from 'react';

/**
 * Specialized component for rendering education and certifications
 * Simple list format optimized for educational credentials
 */
const EducationList = ({ education, title = 'Education & Certifications' }) => {
  if (!education || !education.length) return null;

  return (
    <div>
      <span>{title}</span>
      <ul>
        {education.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </div>
  );
};

export default EducationList;